program Narocanje;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  Auth.Service in 'Auth.Service.pas',
  Client.Settings in 'Client.Settings.pas' {*.html},
  Client.Core in 'Client.Core.pas',
  MobileForm in 'Templates\MobileForm.pas',
  Main in 'Main.pas'{*.html},
  Login in 'Frames\Login.pas'{*.html},
  Narocila in 'Frames\Narocila.pas'{*.html},
  Narocilo in 'Frames\Narocilo.pas'{*.html},
  NarociloInfo in 'Frames\NarociloInfo.pas'{*.html},
  MenjavaGesla in 'Frames\MenjavaGesla.pas'{*.html},
  Constants in 'Constants.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TmodMain, modMain);
  Application.CreateForm(TfrmMain, frmMain);
  Application.Run;
end.
